"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5250],{

/***/ 69541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RHFAutoComplete; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87536);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49624);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87918);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13362);






// form

// @mui

// ----------------------------------------------------------------------
RHFAutoComplete.propTypes = {
    name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    label: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
function RHFAutoComplete(_param) {
    var name = _param.name, label = _param.label, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "name",
        "label"
    ]);
    var control = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .Gc)().control;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .Controller */ .Qr, {
        name: name,
        control: control,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                fullWidth: true
            }, field), {
                onChange: function(_, newValue) {
                    return field.onChange(newValue);
                },
                getOptionLabel: function(option) {
                    return (option === null || option === void 0 ? void 0 : option.title) || "";
                },
                isOptionEqualToValue: function(option, value) {
                    return option.id === value.id;
                },
                renderTags: function(values, getTagProps) {
                    return values.map(function(option, index) {
                        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, getTagProps({
                            index: index
                        })), {
                            key: option.id,
                            size: "small",
                            label: option.title
                        }));
                    });
                },
                renderInput: function(params) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        label: label
                    }, params), {
                        error: !!error,
                        helperText: error === null || error === void 0 ? void 0 : error.message
                    }));
                }
            }), other));
        }
    });
}


/***/ }),

/***/ 15250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ QuestionCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(78445);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/material/AvatarGroup/AvatarGroup.js + 1 modules
var AvatarGroup = __webpack_require__(51107);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 8 modules
var Select = __webpack_require__(153);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Pagination/Pagination.js + 6 modules
var Pagination = __webpack_require__(10633);
// EXTERNAL MODULE: ./node_modules/highlight.js/es/index.js
var es = __webpack_require__(20637);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js + 1 modules
var notistack_esm = __webpack_require__(56254);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var react_redux_es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/Avatar.js
var Avatar = __webpack_require__(2813);
// EXTERNAL MODULE: ./src/components/ConfirmDialog.js
var ConfirmDialog = __webpack_require__(36165);
// EXTERNAL MODULE: ./src/components/EmptyContent.js
var EmptyContent = __webpack_require__(77251);
// EXTERNAL MODULE: ./src/components/FBSocial.js
var FBSocial = __webpack_require__(36239);
// EXTERNAL MODULE: ./src/components/Iconify.js
var Iconify = __webpack_require__(22554);
// EXTERNAL MODULE: ./src/components/Label.js
var Label = __webpack_require__(41451);
// EXTERNAL MODULE: ./src/components/Markdown.js
var Markdown = __webpack_require__(81320);
// EXTERNAL MODULE: ./src/components/skeleton/SkeletonItem.js
var SkeletonItem = __webpack_require__(37549);
// EXTERNAL MODULE: ./src/hooks/useAuth.js
var useAuth = __webpack_require__(77364);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/redux/slices/blog/blog.question.js
var blog_question = __webpack_require__(29061);
// EXTERNAL MODULE: ./src/service/blog/blog.comment.service.js
var blog_comment_service = __webpack_require__(75291);
// EXTERNAL MODULE: ./src/service/blog/blog.question.service.js
var blog_question_service = __webpack_require__(18741);
// EXTERNAL MODULE: ./src/service/blog/blog.statistic.service.js
var blog_statistic_service = __webpack_require__(47562);
// EXTERNAL MODULE: ./src/utils/createAvatar.js
var createAvatar = __webpack_require__(2410);
// EXTERNAL MODULE: ./src/utils/formatNumber.js
var formatNumber = __webpack_require__(87850);
// EXTERNAL MODULE: ./src/utils/urlSlug.js
var urlSlug = __webpack_require__(98611);
// EXTERNAL MODULE: ./src/sections/comment/CommentItem.js
var CommentItem = __webpack_require__(83741);
// EXTERNAL MODULE: ./src/sections/comment/CommentNewForm.js
var CommentNewForm = __webpack_require__(79136);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@mui/lab/LoadingButton/LoadingButton.js + 1 modules
var LoadingButton = __webpack_require__(31812);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./src/components/hook-form/RHFAutoComplete.js
var RHFAutoComplete = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/redux/slices/blog/blog.tag.js + 1 modules
var blog_tag = __webpack_require__(30910);
// EXTERNAL MODULE: ./src/components/hook-form/index.js + 18 modules
var hook_form = __webpack_require__(54397);
;// CONCATENATED MODULE: ./src/sections/blog/question/QuestionEditForm.js
/* eslint-disable react/prop-types */ 








// form


// @mui







// components




// ----------------------------------------------------------------------
var RootStyles = (0,styled/* default */.ZP)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(1),
        borderRadius: Number(theme.shape.borderRadius)
    };
});
function QuestionEditForm(param) {
    var id = param.id, content = param.content, qTags = param.qTags, setEditable = param.setEditable;
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var translate = (0,useLocales/* default */.Z)().translate;
    var theme = (0,useTheme/* default */.Z)();
    var isAuthenticated = (0,useAuth/* default */.Z)().isAuthenticated;
    var description = "qdescription".concat(id);
    var search = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.blogQuestion;
    }).search;
    var ref = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.blogTag;
    }), tags = ref.tags, searchTag = ref.search, isLoadingTag = ref.isLoading;
    var NewItemSchema = yup_es/* object */.Ry().shape((0,_define_property/* default */.Z)({}, description, yup_es/* string */.Z_().required(translate("validation.required"))));
    var defaultValues = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, description, content || ""), (0,_define_property/* default */.Z)(_obj, "tags", qTags || []), _obj;
    }, [
        id
    ]);
    (0,react.useEffect)(function() {
        var timeout = setTimeout(function() {
            dispatch((0,blog_tag/* getTags */.NJ)());
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        searchTag
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var handleFilterTitleTag = function(_, value) {
        dispatch((0,blog_tag/* setTagSearch */.tx)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchTag), {
            value: value,
            page: 0,
            filterBys: {
                type: null
            }
        })));
    };
    var methods = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup_module/* yupResolver */.X)(NewItemSchema),
        defaultValues: defaultValues
    });
    var reset = methods.reset, handleSubmit = methods.handleSubmit, isSubmitting = methods.formState.isSubmitting;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var request, resp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isAuthenticated) {
                            enqueueSnackbar(translate("label.signinToGPLX"), {
                                variant: "error"
                            });
                            return [
                                2
                            ];
                        }
                        request = {
                            id: id,
                            status: "ACTIVE",
                            tags: data.tags,
                            description: data[description]
                        };
                        return [
                            4,
                            (0,blog_question_service/* updateQuestionAPI */.PF)(request)
                        ];
                    case 1:
                        resp = _state.sent();
                        if (resp.code === "200") {
                            reset();
                            setEditable(false);
                            enqueueSnackbar(translate("message.updateSuccess"));
                            dispatch((0,blog_question/* setQuestionSearch */.y4)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search), {
                                page: 0
                            })));
                        } else enqueueSnackbar("".concat(resp.code, " - ").concat(resp.message), {
                            variant: "error"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(hook_form/* FormProvider */.RV, {
        methods: methods,
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyles, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(hook_form/* RHFEditor */.LM, {
                    name: description,
                    simple: true,
                    sx: {
                        "& .ql-editor": {
                            height: 90,
                            minHeight: 80
                        },
                        "& .ql-toolbar.ql-snow": {
                            padding: "0px 8px"
                        },
                        "& .ql-formats": {
                            marginRight: "0px!important"
                        },
                        "& .ql-container.ql-snow": (0,_object_spread/* default */.Z)({}, theme.typography.body1)
                    },
                    placeholder: translate("question.create")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    spacing: 2,
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RHFAutoComplete/* default */.Z, {
                            name: "tags",
                            multiple: true,
                            size: "small",
                            fullWidth: false,
                            sx: {
                                minWidth: {
                                    md: 200,
                                    xs: 150
                                }
                            },
                            label: translate("label.topic"),
                            options: tags === null || tags === void 0 ? void 0 : tags.map(function(param) {
                                var id = param.id, title = param.title;
                                return {
                                    id: id,
                                    title: title
                                };
                            }),
                            onInputChange: handleFilterTitleTag,
                            loading: isLoadingTag
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                flexGrow: 1
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            color: "inherit",
                            type: "button",
                            variant: "text",
                            onClick: function() {
                                return setEditable(false);
                            },
                            children: translate("button.close")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                            size: "small",
                            type: "submit",
                            variant: "contained",
                            loading: isSubmitting,
                            sx: {
                                minWidth: 80
                            },
                            children: translate("button.save")
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/blog/question/QuestionCard.js
/* eslint-disable react-hooks/exhaustive-deps */ 






// @mui
























// ----------------------------------------------------------------------
QuestionCard.propTypes = {
    question: (prop_types_default()).object
};
function QuestionCard(param) {
    var question = param.question;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var theme = (0,useTheme/* default */.Z)();
    var translate = (0,useLocales/* default */.Z)().translate;
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var ref8 = (0,useAuth/* default */.Z)(), user = ref8.user, isAuthenticated = ref8.isAuthenticated;
    var search = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.blogQuestion;
    }).search;
    var ref9 = (0,react.useState)(true), isShowComments = ref9[0], setIsShowComments = ref9[1];
    var ref10 = (0,react.useState)(false), isShowReplies = ref10[0], setIsShowReplies = ref10[1];
    var ref11 = (0,react.useState)({
        viewNo: 0,
        likeNo: 0,
        commentNo: 0,
        likers: []
    }), statistic = ref11[0], setStatistic = ref11[1];
    var ref12 = (0,react.useState)(false), open = ref12[0], setOpen = ref12[1];
    var ref13 = (0,react.useState)(false), editable = ref13[0], setEditable = ref13[1];
    (0,react.useEffect)(function() {
        var timeout = setTimeout(function() {
            getStatistic();
            es/* default.highlightAll */.Z.highlightAll();
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        question === null || question === void 0 ? void 0 : question.id
    ]);
    var handleSelectTag = function(value) {
        var tags = [
            value
        ];
        var tagIds = tags === null || tags === void 0 ? void 0 : tags.map(function(t) {
            return t.id;
        }).toString();
        dispatch((0,blog_question/* setQuestionSearch */.y4)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search), {
            page: 0,
            tags: tags,
            filterBys: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search.filterBys), {
                tagIds: tagIds
            })
        })));
    };
    var confirmDeleteItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var resp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,blog_question_service/* deleteQuestionAPI */.gs)(question === null || question === void 0 ? void 0 : question.id)
                        ];
                    case 1:
                        resp = _state.sent();
                        setOpen(false);
                        if (resp.code === "200") {
                            enqueueSnackbar(translate("message.deleteSuccess"), {
                                variant: "success"
                            });
                            dispatch((0,blog_question/* setQuestionSearch */.y4)((0,_object_spread/* default */.Z)({}, search)));
                        } else enqueueSnackbar("".concat(resp.code, " - ").concat(resp.message), {
                            variant: "error"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function confirmDeleteItem() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEdit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setEditable(true);
                return [
                    2
                ];
            });
        });
        return function handleEdit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLike = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var code;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isAuthenticated) {
                            enqueueSnackbar(translate("label.signinToGPLX"), {
                                variant: "error"
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0,blog_statistic_service/* updateLikeAPI */.Sz)(question === null || question === void 0 ? void 0 : question.statistic.id)
                        ];
                    case 1:
                        code = _state.sent().code;
                        code === "200" && getStatistic();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLike() {
            return _ref.apply(this, arguments);
        };
    }();
    var getStatistic = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, code, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,blog_statistic_service/* getStatisticAPI */.CM)(question === null || question === void 0 ? void 0 : question.statistic.id)
                        ];
                    case 1:
                        ref = _state.sent(), code = ref.code, data = ref.data;
                        code === "200" && setStatistic(data);
                        return [
                            2
                        ];
                }
            });
        });
        return function getStatistic() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                disableTypography: true,
                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    src: question === null || question === void 0 ? void 0 : (ref = question.createdBy) === null || ref === void 0 ? void 0 : ref.photoURL,
                    alt: question === null || question === void 0 ? void 0 : (ref1 = question.createdBy) === null || ref1 === void 0 ? void 0 : ref1.displayName,
                    color: (question === null || question === void 0 ? void 0 : (ref2 = question.createdBy) === null || ref2 === void 0 ? void 0 : ref2.photoURL) ? "default" : (0,createAvatar/* default */.Z)(question === null || question === void 0 ? void 0 : (ref3 = question.createdBy) === null || ref3 === void 0 ? void 0 : ref3.displayName).color,
                    children: (0,createAvatar/* default */.Z)(question === null || question === void 0 ? void 0 : (ref4 = question.createdBy) === null || ref4 === void 0 ? void 0 : ref4.displayName).name
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "subtitle2",
                    color: "text.primary",
                    noWrap: true,
                    sx: {
                        cursor: "pointer"
                    },
                    children: question === null || question === void 0 ? void 0 : (ref5 = question.createdBy) === null || ref5 === void 0 ? void 0 : ref5.displayName
                }),
                subheader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "caption",
                    sx: {
                        display: "block",
                        color: "text.secondary"
                    },
                    children: question.createdAt
                }),
                action: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    children: [
                        (user === null || user === void 0 ? void 0 : user.id) === (question === null || question === void 0 ? void 0 : question.createdBy.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: handleEdit,
                            size: "small",
                            color: "primary",
                            variant: "text",
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "circum:edit",
                                sx: {
                                    height: 18,
                                    width: 18
                                }
                            }),
                            children: translate("button.edit")
                        }),
                        (user === null || user === void 0 ? void 0 : user.id) === (question === null || question === void 0 ? void 0 : question.createdBy.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            size: "small",
                            color: "error",
                            variant: "text",
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "octicon:trash-16",
                                sx: {
                                    height: 18,
                                    width: 18
                                }
                            }),
                            onClick: function() {
                                return setOpen(true);
                            },
                            children: translate("button.delete")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                sx: {
                    px: 3,
                    py: 1
                },
                children: [
                    editable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionEditForm, {
                        id: question === null || question === void 0 ? void 0 : question.id,
                        qTags: question === null || question === void 0 ? void 0 : question.tags,
                        content: question === null || question === void 0 ? void 0 : question.description,
                        isEdit: true,
                        setEditable: setEditable
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: question === null || question === void 0 ? void 0 : (ref6 = question.tags) === null || ref6 === void 0 ? void 0 : ref6.map(function(tag) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                        sx: {
                                            mr: 1,
                                            cursor: "pointer"
                                        },
                                        onClick: function() {
                                            return handleSelectTag(tag);
                                        },
                                        children: tag.title
                                    }, tag.id);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ql-snow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ql-editor",
                                    style: {
                                        padding: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* default */.Z, {
                                        children: question === null || question === void 0 ? void 0 : question.description
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FBSocial/* SocialShare */.D, {
                                title: (0,urlSlug/* getString */.K)(question === null || question === void 0 ? void 0 : question.description),
                                url: "https://onthibanglaixe.net/questions/".concat(question === null || question === void 0 ? void 0 : question.id)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: {
                            xs: "column",
                            sm: "row"
                        },
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        color: "inherit",
                                        variant: "text",
                                        size: "small",
                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                            icon: "humbleicons:chat",
                                            sx: {
                                                height: 18,
                                                width: 18
                                            }
                                        }),
                                        sx: (0,_object_spread/* default */.Z)({}, theme.typography.body2),
                                        onClick: function() {
                                            return setIsShowComments(!isShowComments);
                                        },
                                        children: [
                                            isShowComments ? "Ẩn" : "Hiện",
                                            " ",
                                            translate("button.comment").toLowerCase(),
                                            " (",
                                            statistic === null || statistic === void 0 ? void 0 : statistic.commentNo,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "inherit",
                                        variant: "text",
                                        size: "small",
                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                            icon: "bi:reply",
                                            sx: {
                                                height: 18,
                                                width: 18
                                            }
                                        }),
                                        sx: (0,_object_spread/* default */.Z)({}, theme.typography.body2),
                                        onClick: function() {
                                            return setIsShowReplies(!isShowReplies);
                                        },
                                        children: translate("button.reply")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            defaultChecked: true,
                                            onChange: handleLike,
                                            size: "small",
                                            color: "error",
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                                icon: "eva:heart-fill"
                                            }),
                                            checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                                icon: "eva:heart-fill"
                                            })
                                        }),
                                        label: (0,formatNumber/* fShortenNumber */.v1)(statistic === null || statistic === void 0 ? void 0 : statistic.likeNo)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarGroup/* default */.Z, {
                                        max: 5,
                                        sx: {
                                            "& .MuiAvatar-root": {
                                                width: 22,
                                                height: 22
                                            }
                                        },
                                        children: statistic === null || statistic === void 0 ? void 0 : (ref7 = statistic.likers) === null || ref7 === void 0 ? void 0 : ref7.map(function(person) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                alt: person.displayName,
                                                src: person.photoURL
                                            }, person.displayName);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    isShowReplies && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentNewForm/* default */.Z, {
                        itemId: question === null || question === void 0 ? void 0 : question.id,
                        type: "QUESTION"
                    }),
                    isShowComments && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList, {
                        itemId: question === null || question === void 0 ? void 0 : question.id
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog/* default */.Z, {
                values: {
                    title: translate("message.dialogDeleteTitle"),
                    content: translate("message.dialogDeleteContent")
                },
                onClose: function() {
                    return setOpen(false);
                },
                isOpen: open,
                onSubmit: confirmDeleteItem
            })
        ]
    });
}
CommentList.propTypes = {
    itemId: (prop_types_default()).number.isRequired
};
function CommentList(param) {
    var itemId = param.itemId;
    var translate = (0,useLocales/* default */.Z)().translate;
    var ref = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.blogComment;
    }), searchComment = ref.search;
    var ref1 = (0,react.useState)("0"), sortBy = ref1[0], setSortBy = ref1[1];
    var ref2 = (0,react.useState)({
        page: 0,
        size: 10,
        value: "%%",
        orders: [
            {
                order: "desc",
                property: "createdAt"
            }
        ],
        filterBys: {
            itemId: itemId,
            type: "QUESTION"
        }
    }), search = ref2[0], setSearch = ref2[1];
    var ref3 = (0,react.useState)({
        isLoading: false,
        totalPages: 0,
        numberOfElements: 0,
        comments: []
    }), response = ref3[0], setResponse = ref3[1];
    (0,react.useEffect)(function() {
        var timeout = setTimeout(function() {
            getComments();
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        search,
        itemId,
        searchComment
    ]);
    var getComments = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, code, comments, totalPages, numberOfElements;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setResponse((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, response), {
                            isLoading: true
                        }));
                        return [
                            4,
                            (0,blog_comment_service/* findCommentAPI */.bz)(search)
                        ];
                    case 1:
                        ref = _state.sent(), code = ref.code, comments = ref.data, totalPages = ref.totalPages, numberOfElements = ref.numberOfElements;
                        if (code === "200") setResponse((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, response), {
                            comments: comments,
                            totalPages: totalPages,
                            numberOfElements: numberOfElements,
                            isLoading: false
                        }));
                        else setResponse((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, response), {
                            isLoading: false
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function getComments() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangePage = function(_, value) {
        setSearch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search), {
            page: value - 1
        }));
    };
    var handleChangeSort = function(event) {
        var value = event.target.value;
        var orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        if (value === "0") orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        else if (value === "1") orders = [
            {
                order: "asc",
                property: "createdAt"
            }
        ];
        else orders = [
            {
                order: "desc",
                property: "likeNo"
            }
        ];
        setSearch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search), {
            page: 0,
            orders: orders
        }));
        setSortBy(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                my: 1,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "caption",
                                children: [
                                    translate("label.sortBy"),
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                                variant: "standard",
                                value: sortBy,
                                size: "small",
                                sx: {
                                    fontSize: 12,
                                    fontWeight: "bold",
                                    ml: 1,
                                    pt: 1
                                },
                                disableUnderline: true,
                                onChange: handleChangeSort,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        value: "0",
                                        sx: {
                                            fontSize: 12
                                        },
                                        children: translate("label.sortByNew")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        value: "1",
                                        sx: {
                                            fontSize: 12
                                        },
                                        children: translate("label.sortByOld")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        value: "2",
                                        sx: {
                                            fontSize: 12
                                        },
                                        children: translate("label.sortByLike")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            response === null || response === void 0 ? void 0 : response.comments.map(function(comment) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentItem/* CommentItemWrapper */.w, {
                                    comment: comment
                                }, comment.id);
                            }),
                            (response === null || response === void 0 ? void 0 : response.isLoading) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonItem/* SkeletonCommentItem */.bG, {}) : (response === null || response === void 0 ? void 0 : response.numberOfElements) == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyContent/* default */.Z, {
                                title: " ",
                                description: translate("label.noComment")
                            })
                        ]
                    }),
                    (response === null || response === void 0 ? void 0 : response.numberOfElements) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        alignItems: "center",
                        my: 1.5,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                            count: response === null || response === void 0 ? void 0 : response.totalPages,
                            variant: "text",
                            page: search.page + 1,
                            onChange: handleChangePage
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 47562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CM": function() { return /* binding */ getStatisticAPI; },
/* harmony export */   "Sz": function() { return /* binding */ updateLikeAPI; },
/* harmony export */   "_l": function() { return /* binding */ updateViewAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10092);
/* harmony import */ var _utils_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92369);



var getStatisticAPI = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var config;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            config = {
                url: "/statistic/".concat(id),
                method: "GET"
            };
            return [
                2,
                (0,_utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .handleRequestBlog */ .p)(config)
            ];
        });
    });
    return function getStatisticAPI(id) {
        return _ref.apply(this, arguments);
    };
}();
var updateViewAPI = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var config;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            config = {
                url: "/statistic/".concat(id, "/view"),
                method: "PUT"
            };
            return [
                2,
                (0,_utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .handleRequestBlog */ .p)(config)
            ];
        });
    });
    return function updateViewAPI(id) {
        return _ref.apply(this, arguments);
    };
}();
var updateLikeAPI = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var config;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            config = {
                url: "/statistic/".concat(id, "/like"),
                method: "PUT"
            };
            return [
                2,
                (0,_utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .handleRequestBlog */ .p)(config)
            ];
        });
    });
    return function updateLikeAPI(id) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 98611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getString; }
/* harmony export */ });
/* unused harmony export getSlug */
/* harmony import */ var url_slug__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4099);

var getSlug = function(value) {
    var url = urlSlug.convert(value, {
        separator: "-",
        transformer: urlSlug.LOWERCASE_TRANSFORMER,
        dictionary: {
            "đ": "d",
            "Đ": "d"
        }
    });
    return url;
};
var getString = function(value) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 150;
    var regex = /(<([^>]+)>)/gi;
    return value.replace(regex, "").substring(0, length);
};


/***/ })

}]);